module.exports = __webpack_public_path__ + "img/form_faultlist.5c3622f5.svg";